export const SET_PASSWORD = 'app/ActivateUser/SET_PASSWORD'
export const SET_REPEAT_PASSWORD = 'app/ActivateUser/SET_REPEAT_PASSWORD'
export const ACTIVATE_USER = 'app/ActivateUser/ACTIVATE_USER'
export const ACTIVATE_USER_DONE = 'app/ActivateUser/ACTIVATE_USER_DONE'
export const ACTIVATE_USER_ERROR = 'app/ActivateUser/ACTIVATE_USER_ERROR'
